import React, { useEffect, useState } from "react";
import InputModal from "../../components/modals/InputModal";
import TableAction from "../../components/TableAction";
import WithAuth from "../../hoc/WithAuth";
import InputsTable from "../../components/tables/InputsTable";

function InputPage() {
  const [searchText, setSearchText] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState(false);

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div
      className=" md:bg:white md:px-[50px]"
      style={{
        borderRadius: 8.5,
        marginTop: 25,
        paddingTop: 22,
      }}
    >
      <InputModal open={open} selectedId={selectedId} hideModal={hideModal} />
      <div
        className="hidden md:flex print:h-0 h-[80px]"
        style={{
          alignItems: "center",
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction setSearchText={setSearchText} onCreateNew={handleCreate} />
      </div>
      <InputsTable searchText={searchText} />
    </div>
  );
}

export default WithAuth(InputPage);
